module.exports = __webpack_public_path__ + "img/mail.f9d86488.svg";